<template>
  <ValidationObserver ref="observer" tag="form" @submit.prevent="submit()">
    <div class="flex justify-center flex-col">
      <p class="mb-5 text-red-400" v-if="error">{{error}}</p>
      <ValidationProvider rules="required" v-slot="{ errors }" name="username">
        <input v-model="username" class="form-input text-xl w-full" type="text" :placeholder="$t('login_username')">
        <p class="text-red-400" v-if="errors[0]">{{$t('login_wrongUsername')}}</p>
      </ValidationProvider>
      <ValidationProvider v-slot="{ errors }" name="password" rules="required">
        <input v-model="password" class="form-input mt-2 text-xl w-full" type="password" :placeholder="$t('login_password')">
        <p class="text-red-400" v-if="errors[0]">{{$t('login_wrongPassword')}}</p>
      </ValidationProvider>
      <v-button type="submit" class="mt-12 bg-transmaes-green" :label="$t('login_label')"/>
    </div>
  </ValidationObserver>
</template>

<script>
  import { mapActions } from 'vuex';
  import VButton from '../common/VButton';

  export default {
    name: 'LoginForm',
    components: {
      VButton,
    },
    data() {
      return {
        username: null,
        password: null,
        error: null,
      };
    },
    methods: {
      ...mapActions('auth', {
        login: 'login',
      }),
      submit() {
        this.$refs.observer.validate().then(() => {
          if (this.$refs.observer.errors.username.length === 0 && this.$refs.observer.errors.password.length === 0) {
            this.login({
              username: this.username,
              password: this.password,
            })
              .then(() => {
                this.$router.push({ name: 'overview' })
                  .catch();
              })
              .catch((error) => {
                if (error.response && error.response.data.message) {
                  this.error = this.$i18n.t('error_wrongCredentials');
                }
              });
          }
        });
      },
    },
  };

</script>
